import { RESET_STATE } from 'store/global/actions';

import { SURVEILLANCE_ACTION_TYPE } from '../actions';

const initialState = { data: null, isLoading: false, hasError: false };

const surveillanceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SURVEILLANCE_ACTION_TYPE.SET_SURVEILLANCE_LOADING:
      return { ...state, isLoading: payload, hasError: payload ? false : state.hasError };

    case SURVEILLANCE_ACTION_TYPE.SET_SURVEILLANCE_ERROR:
      return { ...state, isLoading: false, hasError: true };

    case SURVEILLANCE_ACTION_TYPE.GET_SURVEILLANCE:
      return { data: payload ?? null, isLoading: false, hasError: false };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default surveillanceReducer;
